module.exports = __webpack_public_path__ + "assets/img/title-edaf52bb.png";